/**
 * PostHog Redux Action Creators
 */

import {
  PosthogActionTypes,
  PosthogEventProperties,
  TrackEventAction,
} from './types';

export const trackEvent = (
  event: string,
  properties?: PosthogEventProperties
): TrackEventAction => ({
  type: PosthogActionTypes.TRACK_EVENT,
  payload: {
    event,
    properties,
  },
});